<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headersPdi"
            :items="filteredListaPdi"
            no-data-text="Ainda sem ciclos cadastrados."
          >
            <template #[`item.status`]="{ item }">
              <div class="status-pdi" :class="getStatusPdiClass(item.status)">
                {{ item.status }}
              </div>
            </template>
            <template #[`item.acao`]="{ item }">
              <div @click="$emit('toggle-form', item.id)" class="acoes-tabela">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="icone-acao">
                      {{ isHistorico ? 'fas fa-eye' : 'fas fa-pen' }}
                    </v-icon>
                  </template>
                  <span>Editar PDI</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row v-if="historicoProgresso.length">
        <v-col cols="12">
          <TimelinePdi :historicoProgresso="historicoProgresso" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TimelinePdi from './TimelinePdi.vue';

export default {
  name: 'ViewInicialPdi',
  components: { TimelinePdi },
  props: {
    listaPdi: {
      type: Array,
      required: true,
      default: () => [],
    },
    historicoProgresso: {
      type: Array,
      default: () => [],
    },
    isHistorico: { type: Boolean, default: false },
  },
  data() {
    return {
      headersPdi: [
        { text: 'Objetivo', value: 'objetivo' },
        { text: 'Prazo', value: 'prazo' },
        { text: 'Prioridade', value: 'prioridade' },
        { text: 'Status', value: 'status' },
        { text: 'Ação', value: 'acao' },
      ],
    };
  },
  computed: {
    filteredListaPdi() {
      if (this.isHistorico)
        return this.listaPdi.filter(item => item.status.toLowerCase() === 'finalizado');
      return this.listaPdi;
    },
  },
  methods: {
    getStatusPdiClass(status) {
      if (status.toLowerCase() === 'em andamento') return 'andamento';
      else if (status.toLowerCase() === 'finalizado') return 'finalizado';
    },
  },
};
</script>

<style scoped>
.status-pdi {
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  color: #fff;
  padding: 0.5rem 0.25rem;
  border-radius: 8px;
  background: #d9d9d9;
}
.status-pdi.andamento {
  background: #f8ba00;
}
.status-pdi.finalizado {
  background: #258b97;
}
</style>
